/* Keep Langify's actual switchers and handlers inside the revamp header. */
(function () {
  'use strict';
  function start() {
    var slot = document.querySelector('[data-ib-header-language]');
    if (!slot) return;

    var pair = document.querySelector('[data-ib-article-pair]');
    var pairForm = pair && pair.querySelector('form');
    var submitting = false;
    window.addEventListener('pageshow', function () { submitting = false; });

    function pairTarget(code) {
      var locale = String(code || '').toLowerCase();
      if (!pairForm || (locale !== 'en' && locale !== 'zh' && locale !== 'zh-tw')) return null;
      var chinese = locale.indexOf('zh') === 0;
      var raw = pair.getAttribute(chinese ? 'data-zh-url' : 'data-en-url');
      if (!raw) return null;
      try {
        var url = new URL(raw, window.location.origin);
        if (url.origin !== window.location.origin || url.search || url.hash) return null;
        var path = url.pathname.replace(/^\/(?:zh|zh-TW)(?=\/)/i, '');
        if (!/^\/blogs\/[^/]+\/[^/]+$/.test(path) || /%2f|%5c/i.test(path)) return null;
        var target = new URL((chinese ? '/zh' : '') + path, window.location.origin);
        var current = new URL(window.location.href);
        current.searchParams.forEach(function (value, key) {
          if (/^(preview_theme_id|preview_key|_fd|pb|utm_source|utm_medium|utm_campaign|utm_content|utm_term)$/.test(key)) {
            target.searchParams.append(key, value);
          }
        });
        target.hash = current.hash;
        return target.pathname + target.search + target.hash;
      } catch (error) { return null; }
    }

    slot.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a.ly-languages-switcher-link');
      if (!link || !slot.contains(link)) return;
      var code = link.getAttribute('data-language-code');
      var target = pairTarget(code);
      if (!target || !pairForm.elements.language_code || !pairForm.elements.return_to) return;
      if (event.button && event.button !== 0) return;
      // A modified link opens its explicit paired URL without hijacking the current tab.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        event.stopImmediatePropagation();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting) return;
      submitting = true;
      pairForm.elements.language_code.value = code;
      pairForm.elements.return_to.value = target;
      // Match the installed Langify selector's language-choice cookie; Shopify's
      // native localization POST persists the actual storefront locale.
      document.cookie = 'ly-lang-selected=' + encodeURIComponent(code) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
      HTMLFormElement.prototype.submit.call(pairForm);
    }, true);

    function labelLanguages() {
      slot.querySelectorAll('a.ly-languages-switcher-link').forEach(function (link) {
        var code = link.getAttribute('data-language-code') || '';
        var label = code.toLowerCase().indexOf('zh') === 0 ? '繁體中文' : code.toLowerCase().indexOf('en') === 0 ? 'English' : '';
        if (!label) return;
        var paired = pairTarget(code);
        if (paired && link.getAttribute('href') !== paired) link.setAttribute('href', paired);
        if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
        if (!link.querySelector('.ib-language-label')) {
          var text = document.createElement('span');
          text.className = 'ib-language-label';
          text.textContent = label;
          link.appendChild(text);
        }
      });
    }

    function mountSwitchers() {
      // Move, never clone: app listeners, locale data and current-state classes survive.
      Array.from(document.body.children).forEach(function (node) {
        if (node.classList.contains('ly-switcher-wrapper')) slot.appendChild(node);
      });
      labelLanguages();
    }

    mountSwitchers();
    // App embed may insert its wrappers after this deferred theme script.
    var bodyObserver = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && node.classList.contains('ly-switcher-wrapper');
        });
      })) mountSwitchers();
    });
    bodyObserver.observe(document.body, {childList: true});
    // Labels are idempotent; only this small app-owned slot is watched deeply.
    var slotObserver = new MutationObserver(function (records) {
      if (records.some(function (record) { return record.addedNodes.length > 0; })) labelLanguages();
    });
    slotObserver.observe(slot, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
